import { getRegion } from '../../helpers/getRegion';

const cardsData = {
  com: [
    {
      id: 1,
      title: 'KK Partizan, Serbia',
      content:
        'Sixtix has delivered! By understanding our needs and whishes. Turning anonymous visitors in enriched member profiles. And helped us with a system to sell out easily.\nSmoothly shop, with lots of possibilities. Even a loyalty system to prevent empty seats. A whole new revenue model!',
      author: '- Marketing Director Partizan –',
      imgUrl: './images/partizan.png',
      isList: false,
      listData: [],
    },
    {
      id: 2,
      title: 'SIXTIX NL',
      content:
        'SIXTIX is expanding in the Netherlands with the signing of a major event and festival production company. Join our movement!',
      author: '',
      imgUrl: './images/sixtix_nl.png',
      isList: false,
      listData: [],
    },
    {
      id: 3,
      title: 'Client Support',
      content:
        "“I have never encountered customer service quite like that of SIXTIX; within moments, they deftly resolved my request. It's clear that customer satisfaction is their top priority.”",
      author: '- Jennifer -',
      imgUrl: './images/client_support.png',
      isList: false,
      listData: [],
    },
  ],
  rs: [
    {
      id: 1,
      title: 'KK Partizan, Srbija',
      content:
        'Sixtix je isporučen! Razumevanjem naših potreba i želja. Pretvaranje anonimnih posetilaca u obogaćene profile članova. I pomogao nam je sa sistemom da se lako rasprodamo.\nKupovina je laka, sa puno mogućnosti. Čak i sistem lojalnosti da spreči prazna mesta. Potpuno novi model prihoda!',
      author: '– Direktor Marketinga Partizan –',
      imgUrl: './images/partizan.png',
      isList: true,
      listData: [
        '<strong>3+ godina</strong> saradnje',
        '<strong>100k+ prodatih</strong> karata godišnje',
        '<strong>Prvi resale sistem</strong> karata u Srbiji',
        '<strong>14k+ prodatih</strong> sezonskih karata godišnje',
        '<strong>Dinamicki QR</strong> kod za vlasnike wallet sezonskih karata',
        'Skeniranje karata putem <strong>digital walleta i QR koda</strong>',
        '<strong>20+ različitih</strong> tipova karata po događaju',
      ],
    },
    {
      id: 2,
      title: 'Lovefest, Srbija',
      content: '',
      author: '',
      imgUrl: './images/sixtix_nl.png',
      isList: true,
      listData: [
        '<strong>54000+</strong> Posetilaca',
        '<strong>25+ faza prodaje</strong>',
        'Skeniranje na ulazima',
        '<strong>3k+ Pozivnica</strong> za goste i VIP',
        'Skeniranje karata putem <strong>digital walleta i QR koda</strong>',
      ],
    },
    {
      id: 3,
      title: 'Hapoel Jerusalem B.C.',
      content:
        'Hapoel Jerusalem hosted a few games this season in Belgrade. This is of course a major challenge without having the right partners in place. Thankfully, we found a fantastic partner that we could trust in SixTix to help us set up the stadium in our systems, ensure that access control works perfectly, and that we have tracking of all relevant data from the games. Thanks to the whole team who were there for us, providing great service and professionalism.',
      author: 'Ido Medan-David | Head of Fan Success & Ticket Sales',
      imgUrl: './images/maccabi.JPG',
      isList: false,
      listData: [],
    },
  ],
  fr: [
    {
      id: 1,
      title: 'KK Partizan, Serbia',
      content:
        'Sixtix has delivered! By understanding our needs and whishes. Turning anonymous visitors in enriched member profiles. And helped us with a system to sell out easily.\nSmoothly shop, with lots of possibilities. Even a loyalty system to prevent empty seats. A whole new revenue model!',
      author: '- Marketing Director Partizan –',
      imgUrl: './images/partizan.png',
      isList: false,
      listData: [],
    },
    {
      id: 2,
      title: 'SIXTIX NL',
      content:
        'SIXTIX is expanding in the Netherlands with the signing of a major event and festival production company. Join our movement!',
      author: '',
      imgUrl: './images/sixtix_nl.png',
      isList: false,
      listData: [],
    },
    {
      id: 3,
      title: 'Client Support',
      content:
        "“I have never encountered customer service quite like that of SIXTIX; within moments, they deftly resolved my request. It's clear that customer satisfaction is their top priority.”",
      author: '- Jennifer -',
      imgUrl: './images/client_support.png',
      isList: false,
      listData: [],
    },
  ],
  nl: [
    {
      id: 1,
      title: 'KK Partizan, Serbia',
      content:
        'Sixtix has delivered! By understanding our needs and whishes. Turning anonymous visitors in enriched member profiles. And helped us with a system to sell out easily.\nSmoothly shop, with lots of possibilities. Even a loyalty system to prevent empty seats. A whole new revenue model!',
      author: '- Marketing Director Partizan –',
      imgUrl: './images/partizan.png',
      isList: false,
      listData: [],
    },
    {
      id: 2,
      title: 'SIXTIX NL',
      content:
        'SIXTIX is expanding in the Netherlands with the signing of a major event and festival production company. Join our movement!',
      author: '',
      imgUrl: './images/sixtix_nl.png',
      isList: false,
      listData: [],
    },
    {
      id: 3,
      title: 'Client Support',
      content:
        "“I have never encountered customer service quite like that of SIXTIX; within moments, they deftly resolved my request. It's clear that customer satisfaction is their top priority.”",
      author: '- Jennifer -',
      imgUrl: './images/client_support.png',
      isList: false,
      listData: [],
    },
  ],
};

export const getCardsData = () => {
  const domen = getRegion();

  switch (domen) {
    case 'rs':
      return cardsData.rs;

    case 'fr':
      return cardsData.fr;

    case 'nl':
      return cardsData.nl;

    default:
      return cardsData.com;
  }
};
